import store from '@/store'
import redirect from '../redirect'
import { decryptAES } from '../encrypt'

// 解析查询参数并返回对象
function getQueryParams() {
  const queryString = window.location.search // 获取查询字符串
  const params = new URLSearchParams(queryString)
  const paramsObj = {}

  for (const [key, value] of params.entries()) {
    paramsObj[key] = value // 将每个参数添加到对象中
  }

  return paramsObj
}

function strSplit(str) {
  // const str1 = "registerPage;cxd+MTIzNDU2Nzg5;cid+5676879898===";
  // const str2 = "registerPage;affid+MjM5OQ==";
  // alert(str/)
  const regex = /registerPage(.*)/ // 匹配 'registerPage' 后面的所有字符

  const strmatch = str.match(regex)[1]

  const newStr = strmatch.replaceAll(/[;+]/g, match => {
    return match === ';' ? '&' : '='
  })
  const params = new URLSearchParams(newStr)

  const tgLinks = {}
  params.forEach((value, key) => {
    tgLinks[`${key}`] = `${value}`
  })

  store.commit('telegram/setTgLinks', tgLinks)
}

export function telegramEnvInit(locationSearch, router) {
  if (window.Telegram && window.Telegram.WebApp) {
    // 初始化 Telegram WebApp

    // 调用 ready 方法，确保 API 可用
    window.Telegram.WebApp.ready(() => {
      try {
        window.Telegram.WebApp.expand()

        // Global event listener for viewport changes
        window.Telegram.WebApp.onEvent('viewportChanged', () => {})
      } catch (error) {
        console.warn('Telegram error', error)
      }
    })

    // 暂时不让用户使用 Telegram Web
    if (window.Telegram.WebApp.platform === 'web' || window.Telegram.WebApp.platform === 'weba') {
      router.push('/tgWebError')
      return
    }

    // 获取 initDataUnsafe
    const initDataUnsafe = window.Telegram.WebApp.initDataUnsafe.user
    const params = new URLSearchParams(locationSearch)
    const startParam = params.get('tgWebAppStartParam')

    // const startParam = 'c38e24b3acda3251973adf3420051084'; //没有参数
    // const startParam = '6d540e02bba50ba299d2fc425094f56084e16d801c88fece2786329aff4f062ac7c759fcb5ed0dda5435625bc65135b0'; //2参数
    // const startParam = '83f7f3b38c4861904569befec4d52fb4d3b8ae9f8d7099c43cde67000e14802c'; //1参数

    // 先重置 telegramCampaignCode
    store.commit('telegram/setTelegramCampaignCode', '')
    if (startParam) {
      const telegramToRouterPath = decryptAES(startParam)

      let campaignCode
      if (telegramToRouterPath.includes('TYPETRP')) {
        const content = telegramToRouterPath.replaceAll('TYPETRP&', '')
        campaignCode = content.split(';')[1]
        store.commit('telegram/setTelegramCampaignCode', campaignCode)
      } else {
        campaignCode = null
      }

      // 保存跳转路由地址
      // registerPage;affid+MjM5OQ==
      // registerPage;cxd+MTIzNDU2Nzg5
      // 保存跳转路由地址
      if (telegramToRouterPath.search('registerPage') !== -1) {
        store.commit('telegram/setTelegramToRouterPath', 'registerPage')
        strSplit(telegramToRouterPath)

        store.commit('telegram/setSkipResetTgLink', true)
      } else {
        store.commit('telegram/setTelegramToRouterPath', telegramToRouterPath)
      }

      if (initDataUnsafe) {
        const tgparams = {
          telegramId: initDataUnsafe.id,
          username: initDataUnsafe.username,
        }
        store.commit('telegram/setTelegramParams', tgparams)
        store.commit('telegram/setTgBtn', false)
      }

      // 跳转
      if (store.getters['telegram/getTelegramToRouterPath']) {
        if (store.state.common.loginStatus) {
          if (store.getters['telegram/getTelegramToRouterPath'] === 'login') {
            router.push('/home')
          } else {
            router.push(`/${store.getters['telegram/getTelegramToRouterPath']}`)
          }
          store.commit('telegram/setTelegramToRouterPath', '')
        } else if (!router.currentRoute.meta.allowAnonymous) {
          redirect.redirectToLogoutUrl()
        }
      }
    } else {
      const tgParams = getQueryParams()
      const pathname = window.location.pathname

      if (pathname === '/login' || pathname === '/registerPage') {
        if (tgParams.pageResource === 'telegram') {
          // tg
          if (tgParams.telegramId) {
            const tgparams = {
              telegramId: tgParams.telegramId,
            }
            if (tgParams.username && tgParams.username !== 'null' && tgParams.username !== 'undefined') {
              tgparams.username = tgParams.username
            }
            store.commit('telegram/setTelegramParams', tgparams)
          }
          store.commit('telegram/setTgBtn', false)
        } else {
          // h5 && pc
          store.commit('telegram/setTgBtn', true)
        }
      }
    }

    // save original page that user wants to go
    if (['/depositFunds', '/withdrawFunds', '/liveAccount', '/contactUs'].includes(window.location.pathname)) {
      store.commit('telegram/setTgOriPath', window.location.pathname)
    }
  }
}
